/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {CircularProgress, Grid, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";
import SeleccionadorOpciones from "../../Modulo_EnviosT1/Componentes/SeleccionadorOpciones";
import {obtenerCotizaciones} from "../../Modulo_EnviosT1/Funciones/obtenerCotizaciones";
import {obtenerValorProductos} from "../../CodNegocio/Pedido/obtenerValorProductos";
import {contexApp} from "../../App";

const Formulario_Opciones_Envio = ({...props}) => {
    const cData = useContext(contexApp)
    const [opcionesEnvio, setOpcionesEnvio] = useState([])
    const [opcionEscogida, setOpcionEscogida] = useState({})
    const [cargando, setCargando] = useState(false)
    const [valorEnvio, setValorEnvio] = useState(0)
    const [valorProductos, setValorProductos] = useState(0)
    const [yaCotizo, setYaCotizo] = useState(false)
    const [rutas, setRutas] = useState([])


    const cambiar = (token) => {

        let index = opcionesEnvio.findIndex((it) => it.token === token);
        let opcion = opcionesEnvio[index]
        setOpcionEscogida(opcion);
        actualizarValoresOpcion(opcion)

    }

    const actualizarValoresOpcion = (opc) => {
        setValorEnvio(opc.total_cost);
        props.props.setValue('valorEnvio', opc.total_cost);
        props.props.setValue('tokenEnvio', opc.token);
        props.props.setValue('empresaEnvio', opc.carrier);
    }


    const obtenerOpcionMasBarata = (items) => {
        // Manejo de caso para arreglos vacíos
        if (!items || items.length === 0) return null;

        return items.reduce((prev, curr) => {
            return (curr.total_cost < prev.total_cost) ? curr : prev;
        });
    }


    const obtenerOpciones = async () => {

        setCargando(true)
        let pedido = props.props.getValues()
        let dox = await obtenerCotizaciones(pedido)
        if (dox.status === 200 && dox.data[0] && dox.data[0].success) {

            let ops = dox.data[0].detail

            setearValore(ops, pedido)

            const itemRecogerBodega = {
                carrier: 'Recogida en bodega',
                delivery_days: 1,
                service_type: 'Recogida por el cliente',
                total_cost: 0,
                token: 'enBodega'
            }

            ops.push(itemRecogerBodega)
            setOpcionesEnvio(ops)


        }
        setCargando(false)
        setYaCotizo(true)

    }

    const setearValore = (opciones, pedido) =>{

        let masBarato = obtenerOpcionMasBarata(opciones)
        setOpcionEscogida(masBarato)
        actualizarValoresOpcion(masBarato)
        setValorProductos(obtenerValorProductos(pedido.productos))


    }

    const obtenerEnvioGratis = (rutas) => {


        let pedido = props.props.getValues()
        let index = rutas.findIndex((it) => it.municipio === pedido.municipio)
        if (index >= 0) {

            let ruta = rutas[index]
            let totalValor = obtenerValorProductos(pedido.productos)

            if (totalValor >= ruta.valorGratis){

                const envioGratis = {
                    carrier: 'Envio Gratis',
                    delivery_days: 1,
                    service_type: 'Envio por cortesia',
                    total_cost: 0,
                    token: 'Gratis'
                }

                const itemRecogerBodega = {
                    carrier: 'Recogida en bodega',
                    delivery_days: 1,
                    service_type: 'Recogida por el cliente',
                    total_cost: 0,
                    token: 'enBodega'
                }

                setOpcionesEnvio([itemRecogerBodega, envioGratis])
                setearValore([itemRecogerBodega, envioGratis], pedido)
                return true

            }




        }

        return false

    }


    useEffect(() => {


        if (cData.rutas &&  obtenerEnvioGratis(cData.rutas)) {

        }else{
            obtenerOpciones()
        }




    }, [cData]);
    return (

        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                {cargando && opcionesEnvio.length === 0 ?
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        size={12}
                    >

                        <Grid item container size={12} sx={{justifyContent: 'center', marginTop: 8}}>
                            <Typography>Consultando tiempos de Envío</Typography>
                        </Grid>

                        <Grid item container size={12}
                              sx={{justifyContent: 'center', marginTop: 2, marginBottom: 8}}>
                            <CircularProgress/>
                        </Grid>

                    </Grid>

                    :


                    <SeleccionadorOpciones opciones={opcionesEnvio} escogida={opcionEscogida}
                                           setOpcionEscogida={cambiar} yaCotizo={yaCotizo}/>

                }
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: 1, pr: 2}}>
                <Typography sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.palette.primary.main
                }}>{`Valor Envio : ${formatoMoneda(valorEnvio)}`}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: -2, pr: 2}}>
                <Typography sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.palette.primary.main
                }}>{`Valor Compra : ${formatoMoneda(valorProductos)}`}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: -1, pr: 2}}>
                <Typography sx={{
                    fontSize: 20,
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    borderTop: 1,
                    pt: 1
                }}>{`Total Pedido : ${formatoMoneda(valorEnvio + valorProductos)}`}</Typography>
            </Grid>


        </Grid>


    )

}
export default Formulario_Opciones_Envio